import { Button, ButtonProps } from '@mui/material'

export function CustomButton(props: ButtonProps) {
  return (
    <Button
      fullWidth
      sx={{
        width: '100%',
        minWidth: 0,
        backgroundColor: 'primary.main',
        color: 'white',
        '&:hover': {
          backgroundColor: 'primary.dark',
        },
        '&:disabled': {
          backgroundColor: 'grey.300',
          color: 'grey.600',
        },
      }}
      {...props}
    >
      {props.children}
    </Button>
  )
}
